/**
 * Generated from HomeScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function HomeScreenLayout(this: $HomeScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	const shelves = this.shelves;
	$(shelves, 0, shelfShort, {x:3607.1, y:-319.35, w:521.00, h: 199.00});
	$(shelves, 1, shelfMedium, {x:2939.35, y:-305.65, w:592.00, h: 186.00});
	$(shelves, 2, shelfLong, {x:3934.05, y:12.2, w:843.00, h: 180.00});
	const shelfItems = this.shelfItems;
	$(shelfItems, 0, shelfItemRobot, {x:4068.5, y:-47.6});
	$(shelfItems, 1, shelfItemMonster, {x:4060.8, y:244.25});
	$(shelfItems, 2, shelfItemPuzzle, {x:2981.65, y:-203.4});
	$(shelfItems, 3, shelfItemGlockenspiel, {x:2934.25, y:-344.5});
	$(shelfItems, 4, shelfItemCooking, {x:3956.15, y:497.3});
	$(shelfItems, 5, shelfItemCooking, {x:4143.75, y:503.45});
	$(shelfItems, 6, shelfItemCooking, {x:3664.7, y:492});
	$(shelfItems, 7, shelfItemCooking, {x:3483.15, y:487.15});
	$(shelfItems, 8, shelfItemMovie, {x:3582.7, y:242.45});
	$(shelfItems, 9, shelfItemNyatiti, {x:3717.25, y:-450.25});
	$(shelfItems, 10, shelfItemDidgeridoo, {x:3251.6, y:-222.3});
	$(shelfItems, 11, shelfItemBagpipes, {x:3444.25, y:-505.1});
	$(this, "background", background, {x:-1664, y:-768});
	$(this, "roomRight", roomRight, {x:-3330, y:0, w:6658.00, h:1536.00});
	$(this, "doorMask", [-152.95,336.85,-192.00,38.65,-208.20,-95.55,-212.75,-127.15,-214.45,-209.85,-208.20,-268.70,-195.70,-331.30,-185.25,-358.70,-170.95,-375.45,-151.30,-381.85,89.20,-384.40,163.55,-379.25,181.05,-276.30,203.05,-49.55,214.55,152.85,214.40,262.70,202.00,423.40,-129.35,435.20]);
	$(this, "luna", luna, {x:-125.45, y:329, w:618.00, h: 569.00});
	$(this, "door", door, {x:0.6, y:439});
	$(this, "knockKnock", knockKnock, {x:250.7, y:-71.45});
	$(this, "packageOpen", package1, {x:10.8, y:931.75, w:929.00, h: 662.00});
	$(this, "packageInDoor", package1, {x:21.55, y:421.75, w:255.24, h: 181.88});
	$(this, "packageInRoom", package1, {x:-213.55, y:677.2, w:459.72, h: 327.60});
	$(this, "packageBox", packageBox, {x:18.5, y:410});
	$(this, "buttonGo", buttonGo, {x:834.1, y:594.55, w:349.00, h: 357.00});
	$(this, "lunaPrompter", lunaPrompter, {x:-728.5, y:884, w:557.00, h: 555.00});
	$(this, "buttonPackage", buttonPackage, {x:-882.7, y:-14.8});
	return this;
}
function background(this: $background) {
	const tiles = this.tiles;
	$(tiles, 0, home_02, {x:2048, y:0, w:2048.00, h: 1536.00});
	$(tiles, 1, home_01, {x:0, y:0, w:2048.00, h: 1536.00});
	$(tiles, 2, home_04, {x:6144, y:0, w:514.00, h: 1536.00});
	$(tiles, 3, home_03, {x:4096, y:0, w:2048.00, h: 1536.00});
	return this;
}
function home_02(this: $home_02) {
	if (this.setLayoutTexture) this.setLayoutTexture("home_02.jpg", 0.000, 0.000);
	return this;
}
function home_01(this: $home_01) {
	if (this.setLayoutTexture) this.setLayoutTexture("home_01.jpg", 0.000, 0.000);
	return this;
}
function home_04(this: $home_04) {
	if (this.setLayoutTexture) this.setLayoutTexture("home_04.jpg", 0.000, 0.000);
	return this;
}
function home_03(this: $home_03) {
	if (this.setLayoutTexture) this.setLayoutTexture("home_03.jpg", 0.000, 0.000);
	return this;
}
function roomRight(this: $roomRight) {
	return this;
}
function doorMask(this: $doorMask) {
	return this;
}
function luna(this: $luna) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna.png", 0.500, 1.000);
	return this;
}
function door(this: $door) {
	const frames = this.frames;
	$(frames, 0, door2, {x:-78.7, y:84.8, w:310.00, h: 976.00});
	$(frames, 1, door3, {x:-387.3, y:31.75, w:465.00, h: 899.00});
	$(this, "sprite", door1, {x:0, y:0, w:470.00, h: 840.00});
	return this;
}
function door1(this: $door1) {
	if (this.setLayoutTexture) this.setLayoutTexture("door1.png", 0.500, 1.000);
	return this;
}
function door2(this: $door2) {
	if (this.setLayoutTexture) this.setLayoutTexture("door2.png", 0.500, 1.000);
	return this;
}
function door3(this: $door3) {
	if (this.setLayoutTexture) this.setLayoutTexture("door3.png", 0.501, 1.000);
	return this;
}
function knockKnock(this: $knockKnock) {
	const knock = this.knock;
	$(knock, 0, knockWord, {x:8.35, y:-83.75, w:335.00, h: 144.00});
	$(knock, 1, knockWord, {x:-8.4, y:83.7, w:335.00, h: 144.00});
	return this;
}
function knockWord(this: $knockWord) {
	if (this.setLayoutTexture) this.setLayoutTexture("knock-knock.png", 0.500, 0.500);
	return this;
}
function package1(this: $package1) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-1.png", 0.501, 1.000);
	return this;
}
function packageBox(this: $packageBox) {
	const sprites = this.sprites;
	$(sprites, 0, package1, {x:0, y:0, w:929.00, h: 662.00});
	$(sprites, 1, package2, {x:0, y:0, w:929.00, h: 662.00});
	$(sprites, 2, package3, {x:-464.5, y:-685, w:929.00, h: 685.00});
	$(sprites, 3, package4, {x:-463, y:-662, w:987.00, h: 662.00});
	const puzzlePieces = this.puzzlePieces;
	$(puzzlePieces, 0, packagePuzzlePiece1, {x:156.5, y:-1101, w:365.00, h: 365.00});
	$(puzzlePieces, 1, packagePuzzlePiece2, {x:-221, y:-1088.9, w:429.00, h: 431.00});
	$(puzzlePieces, 2, packagePuzzlePiece3, {x:10, y:-881.5, w:393.00, h: 398.00});
	$(this, "boxItemMask", [129.80,-469.25,420.85,-614.20,804.30,-614.20,804.30,-1641.05,-841.60,-1641.05,-841.60,-504.75,-435.70,-504.75]);
	$(this, "itemInBox", itemInBox, {x:-414.8, y:-455.95, w:819.25, h:421.80});
	$(this, "itemAboveBox", itemInBox, {x:-414.8, y:-1084.15, w:819.25, h:421.80});
	$(this, "stamp", packageStampIceland, {x:-422, y:-456, w:518.00, h: 284.00});
	$(this, "tape", package4Tape, {x:144, y:-696, w:385.00, h: 355.00});
	$(this, "flap", package4Flap, {x:-216.35, y:-410.9, w:751.00, h: 190.00});
	$(this, "postcard", postcard, {x:-12.9, y:-1121.1});
	return this;
}
function package2(this: $package2) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-2.png", 0.501, 1.000);
	return this;
}
function package3(this: $package3) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-3.png", 0.000, 0.000);
	return this;
}
function package4(this: $package4) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-4.png", 0.000, 0.000);
	return this;
}
function boxItemMask(this: $boxItemMask) {
	return this;
}
function itemInBox(this: $itemInBox) {
	return this;
}
function packageStampIceland(this: $packageStampIceland) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-stamp-iceland.png", 0.000, 0.000);
	return this;
}
function package4Tape(this: $package4Tape) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-4-tape.png", 0.000, 0.000);
	return this;
}
function package4Flap(this: $package4Flap) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-4-flap.png", 0.500, 0.500);
	return this;
}
function postcard(this: $postcard) {
	$(this, "background", cardBackground, {x:0, y:0, w:966.00, h: 746.00});
	$(this, "image", cardImageThailand, {x:-2.4, y:-53.7, w:829.00, h: 512.00});
	$(this, "buttonSpeaker", buttonSpeaker, {x:350.1, y:274.85, w:127.00, h: 92.00});
	$(this, "title", cardTitle, {x:-75.9, y:232.4, w:663.00, h: 86.00});
	return this;
}
function cardBackground(this: $cardBackground) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-background.png", 0.500, 0.500);
	return this;
}
function cardImageThailand(this: $cardImageThailand) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-image-thailand.png", 0.501, 0.500);
	return this;
}
function buttonSpeaker(this: $buttonSpeaker) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-speaker.png", 0.504, 0.500);
	return this;
}
function cardTitle(this: $cardTitle) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-title-thailand.png", 0.501, 0.000);
	return this;
}
function packagePuzzlePiece1(this: $packagePuzzlePiece1) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-puzzle-piece-1.png", 0.500, 0.500);
	return this;
}
function packagePuzzlePiece2(this: $packagePuzzlePiece2) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-puzzle-piece-2.png", 0.500, 0.500);
	return this;
}
function packagePuzzlePiece3(this: $packagePuzzlePiece3) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-puzzle-piece-3.png", 0.500, 0.500);
	return this;
}
function buttonGo(this: $buttonGo) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-go.png", 0.500, 0.500);
	return this;
}
function shelfShort(this: $shelfShort) {
	if (this.setLayoutTexture) this.setLayoutTexture("shelf-short.png", 0.500, 0.500);
	return this;
}
function shelfMedium(this: $shelfMedium) {
	if (this.setLayoutTexture) this.setLayoutTexture("shelf-medium.png", 0.500, 0.500);
	return this;
}
function shelfLong(this: $shelfLong) {
	if (this.setLayoutTexture) this.setLayoutTexture("shelf-long.png", 0.500, 0.500);
	return this;
}
function shelfItemRobot(this: $shelfItemRobot) {
	$(this, "sprite", shelfItemSprite, {x:-171.65, y:-334.4, w:343.30, h:334.40});
	return this;
}
function shelfItemSprite(this: $shelfItemSprite) {
	return this;
}
function shelfItemPuzzle(this: $shelfItemPuzzle) {
	$(this, "sprite", shelfItemSprite, {x:-205.1, y:37.75, w:404.20, h:313.80});
	$(this, "photoHanger", photoHanger, {x:-6.75, y:59.25, w:112.00, h: 137.00});
	return this;
}
function photoHanger(this: $photoHanger) {
	if (this.setLayoutTexture) this.setLayoutTexture("photo-hanger.png", 0.500, 0.500);
	return this;
}
function shelfItemGlockenspiel(this: $shelfItemGlockenspiel) {
	$(this, "sprite", glockenspiel, {x:-224.35, y:-193.7, r:0.1571, w:483.83, h: 188.99});
	return this;
}
function glockenspiel(this: $glockenspiel) {
	if (this.setLayoutTexture) this.setLayoutTexture("glockenspiel.png", 0.000, 0.000);
	return this;
}
function shelfItemMonster(this: $shelfItemMonster) {
	$(this, "sprite", shelfItemSprite, {x:-223.95, y:-217.75, w:448.35, h:217.90});
	return this;
}
function shelfItemCooking(this: $shelfItemCooking) {
	$(this, "sprite", shelfItemSprite, {x:-87.85, y:-205.4, w:175.85, h:205.45});
	return this;
}
function shelfItemMovie(this: $shelfItemMovie) {
	$(this, "sprite", shelfItemSprite, {x:-242.05, y:-415.7, w:484.35, h:415.75});
	return this;
}
function shelfItemNyatiti(this: $shelfItemNyatiti) {
	$(this, "sprite", nyatitiSprite, {x:0, y:0, r:-0.5236, w:390.33, h: 355.58});
	return this;
}
function nyatitiSprite(this: $nyatitiSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("nyatiti.png", 0.302, 0.700);
	return this;
}
function shelfItemDidgeridoo(this: $shelfItemDidgeridoo) {
	$(this, "sprite", didgeridooSprite, {x:0, y:0, r:-3.1285, w:102.47, h: 745.44});
	return this;
}
function didgeridooSprite(this: $didgeridooSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("didgeridoo.png", 0.594, 0.970);
	return this;
}
function shelfItemBagpipes(this: $shelfItemBagpipes) {
	$(this, "bagpipes", bagpipesInstrument, {x:0, y:0, r:-0.3229, sx:0.339, sy:0.339});
	return this;
}
function bagpipesInstrument(this: $bagpipesInstrument) {
	const startItems = this.startItems;
	$(startItems, 0, bagpipesString1, {x:195.15, y:-295, w:116.80, h: 129.96});
	$(startItems, 1, bagpipesString2, {x:340.65, y:-209.4, r:0.3981, w:189.79, h: 64.17});
	$(startItems, 2, bagpipesString3, {x:416, y:-168.75, r:0.1766, w:147.99, h: 504.98});
	$(startItems, 3, bagpipesPipe1, {x:-215.3, y:124.7, r:0.3304, w:145.00, h: 508.99});
	$(startItems, 4, bagpipesPipe2, {x:-129.85, y:225.65, r:0.1436, w:58.00, h: 397.00});
	$(startItems, 5, bagpipesPipe3, {x:-24.7, y:243.55, r:0.0509, w:270.00, h: 858.00});
	$(startItems, 6, bagpipesPipe4, {x:59.25, y:271.5, r:-0.0204, w:387.99, h: 680.99});
	$(startItems, 7, bagpipesPipe5, {x:164.5, y:279.8, r:-0.0527, w:443.01, h: 612.01});
	$(startItems, 8, bagpipesBagBottom, {x:13.15, y:361.55, r:0.1075, w:702.99, h: 324.40});
	$(startItems, 9, bagpipesBagTop, {x:-237.7, y:250.75, r:0.3265, w:199.71, h: 154.95});
	const items = this.items;
	$(items, 0, bagpipesString1, {x:184.25, y:-358.9, w:142.00, h: 158.00});
	$(items, 1, bagpipesString2, {x:392.7, y:-280.05, w:210.00, h: 71.00});
	$(items, 2, bagpipesString3, {x:523.15, y:-266.1, w:148.00, h: 505.00});
	$(items, 3, bagpipesPipe1, {x:-241.55, y:60.05, w:145.00, h: 509.00});
	$(items, 4, bagpipesPipe2, {x:-130.15, y:157.95, w:58.00, h: 397.00});
	$(items, 5, bagpipesPipe3, {x:-24.6, y:175, w:270.00, h: 858.00});
	$(items, 6, bagpipesPipe4, {x:82.5, y:175.3, w:388.00, h: 681.00});
	$(items, 7, bagpipesPipe5, {x:241.05, y:157.7, w:443.00, h: 612.00});
	$(items, 8, bagpipesBagBottom, {x:37.7, y:344.6, w:703.00, h: 420.00});
	$(items, 9, bagpipesBagTop, {x:-220.3, y:253.8, w:204.00, h: 234.00});
	return this;
}
function bagpipesString3(this: $bagpipesString3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-string-3.png", 0.061, 0.022);
	return this;
}
function bagpipesString2(this: $bagpipesString2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-string-2.png", 0.500, 0.500);
	return this;
}
function bagpipesString1(this: $bagpipesString1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-string-1.png", 0.500, 0.500);
	return this;
}
function bagpipesPipe5(this: $bagpipesPipe5) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-5.png", 0.102, 0.974);
	return this;
}
function bagpipesPipe4(this: $bagpipesPipe4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-4.png", 0.183, 0.988);
	return this;
}
function bagpipesPipe3(this: $bagpipesPipe3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-3.png", 0.130, 0.997);
	return this;
}
function bagpipesPipe2(this: $bagpipesPipe2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-2.png", 0.448, 0.980);
	return this;
}
function bagpipesPipe1(this: $bagpipesPipe1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-1.png", 0.848, 0.984);
	return this;
}
function bagpipesBagBottom(this: $bagpipesBagBottom) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-bag-bottom.png", 0.500, 0.500);
	return this;
}
function bagpipesBagTop(this: $bagpipesBagTop) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-bag-top.png", 0.637, 0.996);
	return this;
}
function lunaPrompter(this: $lunaPrompter) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna-prompter.png", 0.500, 1.000);
	return this;
}
function buttonPackage(this: $buttonPackage) {
	$(this, "sprite", buttonPackageSprite, {x:0, y:0, w:263.00, h: 264.00});
	$(this, "packageTimer", packageTimer, {x:0.85, y:-6.65});
	return this;
}
function buttonPackageSprite(this: $buttonPackageSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-package.png", 0.500, 0.500);
	return this;
}
function packageTimer(this: $packageTimer) {
	$(this, "circle", packageTimerCircle, {x:0, y:0, w:226.00, h:226.00});
	return this;
}
function packageTimerCircle(this: $packageTimerCircle) {
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $HomeScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly shelves: $$array<$shelfShort|$shelfMedium|$shelfLong>;
	readonly shelfItems: $$array<$shelfItemRobot|$shelfItemMonster|$shelfItemPuzzle|$shelfItemGlockenspiel|$shelfItemCooking|$shelfItemMovie|$shelfItemNyatiti|$shelfItemDidgeridoo|$shelfItemBagpipes>;
	readonly background: $background;
	readonly roomRight: $roomRight;
	readonly doorMask: $doorMask;
	readonly luna: $luna;
	readonly door: $door;
	readonly knockKnock: $knockKnock;
	readonly packageOpen: $package1;
	readonly packageInDoor: $package1;
	readonly packageInRoom: $package1;
	readonly packageBox: $packageBox;
	readonly buttonGo: $buttonGo;
	readonly lunaPrompter: $lunaPrompter;
	readonly buttonPackage: $buttonPackage;
}
interface $background extends $$container {
	readonly tiles: $$array<$home_02|$home_01|$home_04|$home_03>;
}
interface $home_02 extends $$sprite {
}
interface $home_01 extends $$sprite {
}
interface $home_04 extends $$sprite {
}
interface $home_03 extends $$sprite {
}
interface $roomRight extends $$container {
}
interface $doorMask extends $$polygon {
}
interface $luna extends $$sprite {
}
interface $door extends $$container {
	readonly frames: $$array<$door2|$door3>;
	readonly sprite: $door1;
}
interface $door1 extends $$sprite {
}
interface $door2 extends $$sprite {
}
interface $door3 extends $$sprite {
}
interface $knockKnock extends $$container {
	readonly knock: $$array<$knockWord>;
}
interface $knockWord extends $$sprite {
}
interface $package1 extends $$sprite {
}
interface $packageBox extends $$container {
	readonly sprites: $$array<$package1|$package2|$package3|$package4>;
	readonly puzzlePieces: $$array<$packagePuzzlePiece1|$packagePuzzlePiece2|$packagePuzzlePiece3>;
	readonly boxItemMask: $boxItemMask;
	readonly itemInBox: $itemInBox;
	readonly itemAboveBox: $itemInBox;
	readonly stamp: $packageStampIceland;
	readonly tape: $package4Tape;
	readonly flap: $package4Flap;
	readonly postcard: $postcard;
}
interface $package2 extends $$sprite {
}
interface $package3 extends $$sprite {
}
interface $package4 extends $$sprite {
}
interface $boxItemMask extends $$polygon {
}
interface $itemInBox extends $$container {
}
interface $packageStampIceland extends $$sprite {
}
interface $package4Tape extends $$sprite {
}
interface $package4Flap extends $$sprite {
}
interface $postcard extends $$container {
	readonly background: $cardBackground;
	readonly image: $cardImageThailand;
	readonly buttonSpeaker: $buttonSpeaker;
	readonly title: $cardTitle;
}
interface $cardBackground extends $$sprite {
}
interface $cardImageThailand extends $$sprite {
}
interface $buttonSpeaker extends $$sprite {
}
interface $cardTitle extends $$sprite {
}
interface $packagePuzzlePiece1 extends $$sprite {
}
interface $packagePuzzlePiece2 extends $$sprite {
}
interface $packagePuzzlePiece3 extends $$sprite {
}
interface $buttonGo extends $$sprite {
}
interface $shelfShort extends $$sprite {
}
interface $shelfMedium extends $$sprite {
}
interface $shelfLong extends $$sprite {
}
interface $shelfItemRobot extends $$container {
	readonly sprite: $shelfItemSprite;
}
interface $shelfItemSprite extends $$container {
}
interface $shelfItemPuzzle extends $$container {
	readonly sprite: $shelfItemSprite;
	readonly photoHanger: $photoHanger;
}
interface $photoHanger extends $$sprite {
}
interface $shelfItemGlockenspiel extends $$container {
	readonly sprite: $glockenspiel;
}
interface $glockenspiel extends $$sprite {
}
interface $shelfItemMonster extends $$container {
	readonly sprite: $shelfItemSprite;
}
interface $shelfItemCooking extends $$container {
	readonly sprite: $shelfItemSprite;
}
interface $shelfItemMovie extends $$container {
	readonly sprite: $shelfItemSprite;
}
interface $shelfItemNyatiti extends $$container {
	readonly sprite: $nyatitiSprite;
}
interface $nyatitiSprite extends $$sprite {
}
interface $shelfItemDidgeridoo extends $$container {
	readonly sprite: $didgeridooSprite;
}
interface $didgeridooSprite extends $$sprite {
}
interface $shelfItemBagpipes extends $$container {
	readonly bagpipes: $bagpipesInstrument;
}
interface $bagpipesInstrument extends $$container {
	readonly startItems: $$array<$bagpipesString1|$bagpipesString2|$bagpipesString3|$bagpipesPipe1|$bagpipesPipe2|$bagpipesPipe3|$bagpipesPipe4|$bagpipesPipe5|$bagpipesBagBottom|$bagpipesBagTop>;
	readonly items: $$array<$bagpipesString1|$bagpipesString2|$bagpipesString3|$bagpipesPipe1|$bagpipesPipe2|$bagpipesPipe3|$bagpipesPipe4|$bagpipesPipe5|$bagpipesBagBottom|$bagpipesBagTop>;
}
interface $bagpipesString3 extends $$sprite {
}
interface $bagpipesString2 extends $$sprite {
}
interface $bagpipesString1 extends $$sprite {
}
interface $bagpipesPipe5 extends $$sprite {
}
interface $bagpipesPipe4 extends $$sprite {
}
interface $bagpipesPipe3 extends $$sprite {
}
interface $bagpipesPipe2 extends $$sprite {
}
interface $bagpipesPipe1 extends $$sprite {
}
interface $bagpipesBagBottom extends $$sprite {
}
interface $bagpipesBagTop extends $$sprite {
}
interface $lunaPrompter extends $$sprite {
}
interface $buttonPackage extends $$container {
	readonly sprite: $buttonPackageSprite;
	readonly packageTimer: $packageTimer;
}
interface $buttonPackageSprite extends $$sprite {
}
interface $packageTimer extends $$container {
	readonly circle: $packageTimerCircle;
}
interface $packageTimerCircle extends $$container {
}
